import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import Tab from "../components/tab";
import { useDispatch, useSelector } from "react-redux";
import {
  dispatchLanguage,
  returnHome,
  saveSkills,
  updateProfileLanguage,
  personal_information
} from "../../../Redux/ActionCreator";
import { ToastContainer, toast } from "react-toastify";
import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";
import { convertSkills } from "../../../Redux/convertResume";

export default function LanguageProficiency({ nextStep, prevStep }) {
  
  const dispatch = useDispatch();
  const language_data = useSelector((lan) => lan.language);
  const secret = useSelector((prev) => prev.secret);
  const Tech_skills = useSelector((e) => e.skills);
  const Personal_skills = useSelector((e) => e.p_skills);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const sidebar = useSelector(e => e.sidebarOpen.message);
  const info = useSelector((info) => info.personal_info);

  const [languages, setLanguages] = useState([
    // { language: "English", rate: "" },
    // { language: "Deutsch", rate: "" },
    // { language: "Hausa", rate: "" },
    // { language: "Kanuri", rate: "" },
  ]);

  const proficiencyLevels = ["Beginner", "Intermediate", "Fluent", "Native"];

  const handleLevelChange = (index, level) => {
    setLanguages((prev) =>
      prev.map((lang, i) => (i === index ? { ...lang, rate: level } : lang))
    );
  };

  useEffect(() => {
    dispatch(dispatchLanguage(languages));
    // save into server cache
    let saveToCache = async () => {
      await saveIntoServerCache("language", languages);
    }
    saveToCache();
  }, [languages])

  useEffect(() => {
    if (language_data.lang !== null) {
      setLanguages(language_data.lang);
    } else {
      let cacheInfo = getOneFromServerCache("language")
      cacheInfo.then(res => res.json())
      .then(res => {
        // console.log("server cache value", res);
        if (res.success == true) {
          let resObj = JSON.parse(res.data);
          // console.log("language respObj", resObj);
          if (resObj !== null && resObj !== undefined) {
            dispatch(dispatchLanguage(resObj));
            // selectedLanguages(resObj);
          }
          // console.log("Done");
        } else if (res.success === false && res.message == "Unauthorized") {
          dispatch(returnHome(res.status));
        }
      })
    }
    
  }, [])

  /* Moving section */
  const handlePrev = () => {
      prevStep();
  }

  const handleNextCall = async () => {
    // handleNext(dispatch, firstName, lastName, nextStep);
    try {
      if (language_data.lang !== null) {
        dispatch(updateProfileLanguage(language_data.lang));
        let data = { ...info.message, languageReviewed: true }
        dispatch(personal_information(data));
        nextStep();
      } else {
        setTimeout(() => {
          toast.error("At least one language is required", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);
      }
    } catch (error) {
        throw error
    }
  }
  
  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly h-calc-100 flex justify-center lg:items-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-10 h-max py-10 px-6 md:px-8 md:py-8 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md`}>
        
        {/* Tabs Section */}
        <div className="flex justify-center w-full">
          <div className="tabarea gap-x-4 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="2" current={false} label="Experience" completed={true} />
            </div>
            <Tab num="3" current={false} label="Skills" completed={true} />
            <Tab num="3" current={true} label="Language" completed={false} />
            <Tab num="4" current={false} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>

        {/* Question with Typing Effect */}
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="text-xl text-center font-semibold my-6 notranslate"
        >
          {flowLanguage == "Spanish" ? (
            <Typewriter key={flowLanguage} words={["¿Cuál es tu nivel de dominio en cada idioma que seleccionaste?"]} loop={1} typeSpeed={40}/>
          ) : (
            <Typewriter key={flowLanguage} words={["What's your proficiency level in each language you selected?"]} loop={1} typeSpeed={40} />
          )}
          {/* <Typewriter words={["What's your proficiency level in each language you selected?"]} loop={1} typeSpeed={40} /> */}
        </motion.p>

        {/* Language Selection with Fade-in Effect */}
        <motion.div
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0, y: 30 },
            visible: { opacity: 1, y: 0, transition: { staggerChildren: 0.3 } },
          }}
          className="flex flex-col gap-6 w-full max-w-[500px] mx-auto mb-4"
        >
          {languages?.map((language, index) => (
            <motion.div
              key={index}
              variants={{ hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0 } }}
              className="md:flex items-center gap-4 w-full"
            >
              {/* Only show the current dropdown if the previous one is filled */}
              {(index === 0 || languages[index - 1].rate !== "") && (
                <>
                  <motion.div
                    className="px-4 py-2 bg-black text-white rounded-md min-w-[100px] text-center vsm:my-4 my-0"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: index * 0.6 }}
                  >
                    {language.language}
                  </motion.div>
                  
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: index * 0.6 }}
                    className="flex items-center gap-4 w-full"
                  >
                    <FormControl fullWidth
                      sx={{
                        // Style the outer input border:
                        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                          borderColor: "orange"
                        },
                        // When focused:
                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "orange"
                        }
                      }}
                    >
                      <InputLabel className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "Selecciona tu nivel de competencia."
                        ) : (
                          "Select your proficiency level"
                        )}                        
                      </InputLabel>
                      <Select
                        value={language.rate}
                        onChange={(e) => handleLevelChange(index, e.target.value)}
                        sx={{
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#FF6633"
                          }
                        }}
                      >
                        {proficiencyLevels.map((level, idx) => (
                          <MenuItem 
                            key={idx} 
                            value={level} 
                            sx={{
                              "&:hover": {
                                backgroundColor: "#FF6633",
                                color: "#fff"
                              }
                            }}
                          >
                            {level}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </motion.div>
                </>
              )}
            </motion.div>
          ))}
        </motion.div>

        {/* Navigation Buttons */}
        <div className="flex justify-center w-full">
          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 4.5 }}
            className="flex justify-between lg:max-w-[90%] w-full">
              <div className="flex justify-center w-full">
                <div className="flex justify-between lg:max-w-[90%] w-full">
                  <button
                      onClick={handlePrev}
                      className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 px-8 rounded-md"
                  >
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "ANTERIOR"
                        ) : (
                          "PREVIOUS"
                        )}
                      </span>
                  </button>
                  
                  <button
                      onClick={handleNextCall}
                      className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 px-6 rounded-md "
                  >
                    <span className="notranslate" key={flowLanguage}>
                      {flowLanguage == "Spanish" ? (
                        "GUARDAR"
                      ) : (
                        "SAVE"
                      )}
                    </span>
                    <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
              </div>
          </motion.div>
        </div>
        

      </div>
      <ToastContainer />
    </div>
  );
}
